import ContactForm from '@/components/ContactUsForm';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const ContactUs = () => {
  const { t } = useTranslation('landing');
  return (
    <Box as='section' id='contact-us'>
      <VStack gap={6} mx='auto' alignItems='start'>
        <Heading as='h2' size={{ base: '5xl', md: '6xl' }} fontWeight='normal'>
          <Text as='span' color='accent' fontWeight='extrabold'>
            {t('contactUs.title1')}
          </Text>
          {t('contactUs.titleJoiner')}
          <Text as='span' color='accent-alt' fontWeight='extrabold'>
            {t('contactUs.title2')}
          </Text>
          <Text as='span' color='accent' fontWeight='extrabold'>
            .
          </Text>
        </Heading>
        <Text color='subtle' mt='5' fontSize='lg'>
          {t('contactUs.description')}
        </Text>
      </VStack>

      <ContactForm />
    </Box>
  );
};
